import React from "react";
import "./auth-form.css";
import Input from "components/input/Input";
import Button from "components/button/Button";

/** One field descriptor passed to <AuthForm>. */
export interface AuthFormField {
  name: string;
  label: string;
  type?: "text" | "password" | "email";
  value: string;
  onChange: (val: string) => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  placeholder?: string;
  autoComplete?: string;
  /** Forwarded to the underlying <input> element. */
  inputRef?: React.RefObject<HTMLInputElement>;
}

interface Props {
  fields: AuthFormField[];
  submitLabel?: string;
  onSubmit: () => void | Promise<void>;
  /** Disables the submit button (e.g. required fields are empty). */
  disabled?: boolean;
  /** Shows "Please wait…" on the button while async work runs. */
  isLoading?: boolean;
  /** Forwarded to the submit <button> element. */
  submitRef?: React.RefObject<HTMLButtonElement>;
}

/**
 * Reusable auth form: a list of Input fields followed by a full-width
 * Button submit button. Used by LoginForm and ChangePasswordForm.
 */
function AuthForm({
  fields,
  submitLabel = "Submit",
  onSubmit,
  disabled,
  isLoading,
  submitRef,
}: Props) {
  return (
    <div className="v1-auth-form">
      {fields.map(({ inputRef, ...fieldProps }) => (
        <Input key={fieldProps.name} ref={inputRef} {...fieldProps} />
      ))}
      <Button
        ref={submitRef}
        className="v1-auth-submit"
        onClick={onSubmit}
        disabled={disabled || isLoading}
      >
        {isLoading ? "Please wait…" : submitLabel}
      </Button>
    </div>
  );
}

export default AuthForm;
